export default function (btnText) {
    return {
        wrapper: this.$el,
        maxLineVisible: 2,
        showAll: false,
        btnToggleIsVisible: false,
        hiddenItem: 0,
        items: [],
        init() {
            this.items = Array.from(
                this.wrapper.querySelectorAll('ul > li.item-link')
            );
            this.resizeTriggerEvent();
            this.removeLoading();
            window.addEventListener('resize', () => this.resizeTriggerEvent());
        },
        resizeTriggerEvent() {
            this.updateVisibility();
            this.toggleButtonIsVisible();
        },
        toggleButtonIsVisible() {
            this.hiddenItem = this.hiddenCount();
            this.btnToggleIsVisible = this.hiddenItem > 0;
        },
        removeLoading() {
            const listEl = this.wrapper.querySelector('ul');
            if (listEl.classList.contains('lp-loader')) {
                listEl.classList.remove('lp-loader');
            }
        },
        hiddenCount() {
            return this.items.filter((item) => item.style.display === 'none')
                .length;
        },
        toggleShowAll() {
            this.showAll = !this.showAll;
            this.updateVisibility();
        },
        updateVisibility() {
            const btnToggleWidth = 60;
            const containerWidth = this.wrapper.querySelector('ul').offsetWidth;
            const maxContainerWidth = containerWidth - btnToggleWidth;
            const gap = 12;
            let currentWidth = 0;
            let lineCount = 1;

            this.items.forEach((item) => {
                if (!item.classList.contains('btn-toggle')) {
                    if (this.showAll) {
                        item.style.display = 'flex';
                    } else {
                        item.style.display = 'flex';
                        const itemWidth = item.offsetWidth + gap;
                        if (currentWidth + itemWidth > maxContainerWidth) {
                            lineCount += 1;
                            currentWidth = 0;
                        }
                        currentWidth += itemWidth;

                        if (lineCount > this.maxLineVisible && !this.showAll) {
                            item.style.display = 'none';
                        }
                    }
                }
            });
        },
        buttonText() {
            return this.showAll ? btnText : `+${this.hiddenItem}`;
        }
    };
}
